import { CarrierType } from '@storage/app/api'
import { SelectOption } from '@storage/app/models'
import { useMemo } from 'react'

const KEY_PREFIX = 'CARRIER_TYPE'

export const useCarrierTypeOptions = (hasUnknown?: boolean): SelectOption[] =>
  useMemo(() => {
    const carrierTypes: SelectOption[] = [
      { label: `${KEY_PREFIX}.VESSEL`, value: CarrierType.Vessel },
      { label: `${KEY_PREFIX}.TRAIN`, value: CarrierType.Train },
      { label: `${KEY_PREFIX}.TRUCK`, value: CarrierType.Truck },
    ]
    if (hasUnknown) carrierTypes.push({ label: `Unknown`, value: CarrierType.Unknown })

    return carrierTypes
  }, [hasUnknown])
